export default "__VITE_ASSET__9b31e9ce__"